<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { computed } from "vue";

const props = defineProps({
    target: {
        type: String,
        required: true,
    },
    label: {
        type: String,
    },
});

const { t } = useI18n();

const skipLabel = computed(() => props.label ?? t("common.skipLink.main-content"));

function focusTarget(event: Event) {
    event.preventDefault();
    const el = document.getElementById(props.target);
    if (el) el.focus();
}
</script>

<template>
    <nav class="skip-link-container" aria-label="Skip to main content">
        <a id="skip-link" :href="`#${target}`" class="skip-link" @click="focusTarget">
            {{ skipLabel }}
        </a>
    </nav>
</template>

<style scoped>
.skip-link {
    position: absolute;
    left: -999px;
    top: 87px;
    background: var(--p-secondary-500);
    color: white;
    font-weight: bold;
    padding: 5px 5px;
    z-index: 9999;
    text-decoration: underline;
    transition: left 0.1s;
    overflow: auto;
}

.skip-link:focus {
    outline: 2px solid white !important;
    left: 7px;
}
</style>
